module.exports = __webpack_public_path__ + "img/clock-square.5cfd9379.svg";